import React, { Component } from 'react';
import { Table, Row, Button, Spin, DatePicker, Radio } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { columnsData } from './data';
import Auth from "../../../table/Auth";
import FileSaver from "file-saver";

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            print: false,
            hotels: [],
            name: "actual"
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }


    getDateData = (date) => {
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');
        const days = moment(date).daysInMonth();
        const name = this.state.name;

        fetch(`/dailyHotels?year=${year}&month=${month}&days=${days}&name=${name}`, { credentials: 'include' }).then(x => x.json()).then(x => {

            let data = x.data || [];
            const hotels = data.map(x => ({ name: x.name, code: x.code }));
            let dataSource = [];
            for (let index = 0; index <= days; index++) {

                dataSource[index] = {
                    day: index == days ? 'Total' : index + 1,
                    ...data.reduce((a, b, i) => {
                        let d = {};
                        const code = b.code || i * i;
                        if (index == days) {
                            d = {
                                [code + 'occ']: b.occ,
                                [code + 'arr']: b.arr,
                                [code + 'rev']: b.rev,
                                [code + 'revpar']: b.revpar,
                                [code + 'total']: b.total,
                                [code + 'available']: b.available,
                                [code + 'occupied']: b.occupied,
                                [code + 'fb']: b.fb,
                            }
                        } else {
                            d = {
                                [code + 'occ']: b.data[index].occ,
                                [code + 'arr']: b.data[index].arr,
                                [code + 'rev']: b.data[index].rev,
                                [code + 'revpar']: b.data[index].revpar,
                                [code + 'total']: b.data[index].total,
                                [code + 'available']: b.data[index].available,
                                [code + 'occupied']: b.data[index].occupied,
                                [code + 'fb']: b.data[index].fb,
                            }
                        }
                        return {
                            ...a,
                            ...d
                        }
                    }, {}),
                };
            }

            this.setState({ loading: false, hotels, data: dataSource });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }


    downloadExcel = async () => {
        const tableName = `${moment(this.state.date).format('YYYY-MM')}`;
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";


        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, hotels } = this.state;
        const columns = [
            ...columnsData(hotels, date, print),
        ];

        const width = hotels.length * 800 + 70;

        return (
            <Spin spinning={this.state.loading} >
                <div className="table7_1_1">
                    <Row className="title" id="table4_1_1" style={{ width: this.state.print ? width * 2 : 'auto' }}>
                        <Row>1.3 酒店月度统计汇总</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <Radio.Group
                                style={{ marginLeft: 10 }}
                                defaultValue={this.state.name}
                                onChange={e => {
                                    this.setState({ name: e.target.value || "actual", loading: true, data: [], }, () => {
                                        this.getDateData(this.state.date)
                                    });
                                }}>
                                <Radio value="actual">This Year</Radio>
                                <Radio value="last_year">Last Year</Radio>
                            </Radio.Group>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: 'auto' }}
                            scroll={this.state.print ? {} : { x: width, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.downloadExcel();
                                    });
                                }}
                                loading={this.state.print}
                            >导出Excel</Button>
                        </Row>
                    </Auth>
                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.3/index.js